"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskLevelBar = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var material_1 = require("@mui/material");
var lodash_1 = __importDefault(require("lodash"));
var RiskLevelBar = function (_a) {
    var issues_overview = _a.issues_overview;
    var _b = (0, react_1.useState)('success.main'), backgroundColor = _b[0], setBackgroundColor = _b[1];
    (0, react_1.useEffect)(function () {
        var color = 'success.main';
        if (!lodash_1.default.isEmpty(issues_overview)) {
            if (issues_overview.low_risk > 0) {
                color = 'info.main';
            }
            if (issues_overview.elevated_risk > 0) {
                color = 'alert.main';
            }
            if (issues_overview.high_risk > 0) {
                color = 'warning.main';
            }
            if (issues_overview.critical > 0) {
                color = 'error.main';
            }
            setBackgroundColor(color);
        }
        else {
            return;
        }
    }, [issues_overview]);
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
            position: 'absolute',
            width: '0.8rem',
            height: '100%',
            backgroundColor: backgroundColor,
            borderTopLeftRadius: '1.0rem',
            borderBottomLeftRadius: '1.0rem',
        } }));
};
exports.RiskLevelBar = RiskLevelBar;
